var map = {
	"./banhanguytin/3.png": "96fc",
	"./chuyencan/3.png": "0621",
	"./daigiadataha/3.png": "322b",
	"./duhanhgia/3.png": "d24c",
	"./thanhsanma/3.png": "086f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b66";